<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code"  clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Farm Group" prop="farmGroup">
                      <el-input v-model="queryCondition.farmGroup" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态" prop="farmGroupStatus">
                      <el-select v-model="queryCondition.farmGroupStatus"  clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="供应商集团名称" prop="supplierGroupName">
                      <el-input v-model="queryCondition.supplierGroupName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition> -->
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <!-- <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span> -->
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_FARMGROUP_ADD" size="mini" class="btn" type="primary" @click="addFarmGroup">新增</el-button>
        <el-button v-acl="RMC_FARMGROUP_DELETE"  size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_FARMGROUP_SAVE" size="mini" class="btn" type="primary" @click="changeStatus(1)">启用</el-button>
        <el-button v-acl="RMC_FARMGROUP_SAVE" size="mini" class="btn" type="primary" @click="changeStatus(2)">禁用</el-button>
        <el-button v-acl="RMC_FARMGROUP_EXPORT" size="mini" class="btn" type="primary" @click="exportData">导出</el-button>
        <el-button v-acl="RMC_FARMGROUP_GEN_TASK" size="mini" class="btn" type="primary" @click="generateTodoList">生成待办任务</el-button>
        <el-button v-acl="RMC_FARMGROUP_DEL_TASK" size="mini" class="btn" type="primary" @click="deleteTodoList">删除待办任务</el-button>

      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Category3" field="category3Name"  width="120" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="Farm Group" min-width="120" field="farmGroup">
            <template v-slot="scope">
                <el-button type="text" @click="goDetail(scope.row)">{{scope.row.farmGroup}}</el-button>
            </template>
        </ux-table-column>
        <ux-table-column align="center" title="状态" min-width="100" field="farmGroupStatus"></ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="120" field="updateName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" min-width="120" field="updateDate"></ux-table-column>
        <ux-table-column align="center" title="关联数据" min-width="120" field="createDate">
            <template v-slot="scope">
                <el-button type="text" @click="examine(scope.row)" >查看</el-button>
            </template>
        </ux-table-column>
      </ux-grid>

      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    

    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">Farm Group关联数据查看</p>
            </div>
        </div>
        <ux-grid v-if="dialogVisible" ref="plxTable" :data="dialogTable" max-height="500" show-overflow="tooltip" highlight-current-row>
            <ux-table-column align="center" title="关联数据" min-width="100" field="name"></ux-table-column>
            <ux-table-column align="center" title="已有数据" min-width="100" field="code"></ux-table-column>
            <ux-table-column align="center" title="操作" min-width="100" >
                <template v-slot="scope">
                    <el-button type="text" @click="goPage(scope.row)">查看</el-button>
                </template>
            </ux-table-column>
        </ux-grid>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="exportDialog" width="30%" >
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">选择季度</p>
            </div>
        </div>
        <el-form :model="ruleForm" :inline="true" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="年" prop="year">
            <el-date-picker :disabled="isBool?true:false" style="width:200px" value-format="yyyy" v-model="ruleForm.year" type="year" placeholder="选择年"> </el-date-picker>
          </el-form-item>
          <el-form-item label="季度" prop="quarter">
            <el-select :disabled="isBool?true:false"  v-model="ruleForm.quarter"  clearable placeholder="请选择" style="width:200px">
              <el-option :key="index" v-for="(item,index) in quarterList" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-row type="flex" justify="center" align="middle">
            <el-button type="primary" @click="exportFarm('ruleForm')">导出</el-button>
            <el-button @click="exportDialog=false">取消</el-button>
          </el-row>
        </el-form>
        
    </el-dialog>


  </div>
</template>
<script>
import aslApi from "@/api/rmcProtein/asl"; 
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './detail/repairDialog.vue'
import commonFunction from "@/utils/dataTableUtils";
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
import farmGroup from "@/api/rmcProduce/farmGroup";
import moment from "moment";


export default {
  name: '',
  components: {
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      quarterList:[{
        name:"Latest",
        code:"0"
      },{
        name:"Q1",
        code:"1"
      },{
        name:"Q2",
        code:"2"
      },{
        name:"Q3",
        code:"3"
      },{
        name:"Q4",
        code:"4"
      }],
      exportDialog:false,
      ruleForm:{},
      routerData:{},
      dialogTable:[{
        name:"RMC评分",
        value:'1'
      },{
        name:"采购量",
        value:'2'
      },{
        name:"农场清单",
        value:'3'
      },{
        name:"审核员清单",
        value:'5'
      },{
        name:"药品清单",
        value:'6'
      },{
        name:"药品用量",
        value:'7'
      }],
      dialogVisible:false,
      ms_roles :JSON.parse(localStorage.getItem('ms_roles')),
      dialoagId:"",
      detailInfo:{},
      allDate:[],
      categoryList2: [],
      categoryList3: [],
      statusList: [],
      multipleSelection:[],
      queryCondition: {
        "category3Code":null,
        "sponsorName":null,
        "farmGroup":null,
        "farmGroupStatus":null,
        "pageNum": 1,
        "pageSize": 15,
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
      rules: {
          year: [
            { required: true, message: '请选择年份', trigger: 'change' }
          ],
          quarter: [
            { required: true, message: '请选择季度', trigger: 'change' }
          ],
      }
    }
  },
  created() {
    let newDialogTable=this.dialogTable
    if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!=-1&&this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!=-1){
      this.dialogTable=newDialogTable
    }else if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!=-1){
      this.dialogTable=[{
         name:"采购量",
         value:'2'
      }]
    }else if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!=-1){
      this.dialogTable.splice(1,1)
    }
    this.queryData();
    this.getCategory3Lists()
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      farmGroup.getFarmGroup(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onDetail(row){
      this.$router.push({
        path:'aaaMarkSheet',
        query:{

        }
      })
    },
    openDetail(row){
        console.log("rowrowrowrow==",row)
    },
    onReset() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition= {
        "category3Code":null,
        "sponsorName":null,
        "farmGroup":null,
        "farmGroupStatus":null,
        "pageNum": 1,
        "pageSize": 15,
      }
      this.queryCondition.pageNum=1
      this.queryData();
    },
    handleClose(){
      this.dialogVisible=false
      this.queryData()
    },
    examine(row){
        this.routerData=row
        farmGroup.getRmcReferenceList(row.rmcProduceFarmGroupId).then((res)=>{
          if(res.code==200){
            if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!=-1&&this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!=-1){
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isPurchaseVolumeMaintained
              this.dialogTable[2].code=res.data.isFarmMaintained
              this.dialogTable[3].code=res.data.isAuditorMaintained
              this.dialogTable[4].code=res.data.isDrugListMaintained
              this.dialogTable[5].code=res.data.isDrugDosageMaintained
            }else if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!=-1){
              this.dialogTable[0].code=res.data.isPurchaseVolumeMaintained
            }else if(this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!=-1){
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isFarmMaintained
              this.dialogTable[2].code=res.data.isAuditorMaintained
              this.dialogTable[3].code=res.data.isDrugListMaintained
              this.dialogTable[4].code=res.data.isDrugDosageMaintained
            }else{
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isPurchaseVolumeMaintained
              this.dialogTable[2].code=res.data.isFarmMaintained
              this.dialogTable[3].code=res.data.isAuditorMaintained
              this.dialogTable[4].code=res.data.isDrugListMaintained
              this.dialogTable[5].code=res.data.isDrugDosageMaintained
            }
            
            this.dialogVisible=true
          }else{
            this.$message.error(res.msg)
          }
        })
    },
    release() {
      if(this.multipleSelection.length!=0){
        let arr=[]
        this.multipleSelection.forEach((v)=>{
          arr.push(v.ttQspiAaaScoreId)
        })
        scoreSummary.summaryRelease(arr).then((res)=>{
          if(res.code==200){
            this.$message.success('发布成功')
            this.queryData()
          }else{
            this.$message.error(res.msg)
          }
        })
      }else{
        this.$message.error('请勾选数据')
      }
      
    },
    goPage(val){
      console.log("valvalvla",this.routerData)
      this.$store.dispatch('saveQueryData',this.routerData)
      if(val.value==1){
        this.$router.push({
          path:"rmcProdScore"
        })
      }else if(val.value==2){
        this.$router.push({
          path:"rmcProdPcQty",
          query: {
            // category3Code: this.routerData.category3Code,
            sponsorName:this.routerData.sponsorName
          }
        })
      }else if(val.value==3){
        this.$router.push({
          path:"rmcProdFarm",
          query: {
            // category3Code: this.routerData.category3Code,
            // sponsorName: this.routerData.sponsorName,
            farmGroup: this.routerData.farmGroup,
          }
        })
      }else if(val.value==5){
        this.$router.push({
          path:"rmcProdAuditor",
          query: {
            // category3Code: this.routerData.category3Code,
            // sponsorName: this.routerData.sponsorName,
            farmGroup: this.routerData.farmGroup,
          }
        })
      }else if(val.value==6){
        this.$router.push({
          path:"rmcProdMedicine",
        })
      }else if(val.value==7){
        this.$router.push({
          path:"rmcProdMedUsage"
        })
      }
    },
    changeColor({ row, column, rowIndex, columnIndex }){
      if(row.vsToLastBefore<0||row.vsToLastPeriod<0){
        return 'yellow_class'
      }
    },
    goDetail(row){
        this.$router.push({
            path:"/rmcProdFarmGroup/detail",
            query:{
                id:row.rmcProduceFarmGroupId
            }
        })
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    //根据选中Category2查询Category3
    getCategory3Lists() {
      aslApi.getCategory3(['rmc.RmcCategory3','rmc.RmcProteinAslStatus']).then((res)=>{
        if(res.code==200){
          let newArr=[]
          let statusList=[]
          let newObj=res.data
          for(let item in newObj){
            if(item=='rmc.RmcCategory3'){
              newArr=newObj[item]
            }
            if(item=='rmc.RmcProteinAslStatus'){
              statusList=newObj[item]
            }
          }
          this.categoryList3=newArr.filter((v)=>{
            return v.cascadeKey=='produce'
          })
          this.statusList=statusList

        }else{
          this.$message.error(res.msg)
        }
        console.log("获取的列表====",res)
      })
    },
    getDeleteStatus(){
      for(let i=0;i<this.multipleSelection.length;i++){
        if(this.multipleSelection[i].isEnabled=='Y'){
          return 3
        }else if(this.multipleSelection[i].isRmcScoreMaintained=='Y'||this.multipleSelection[i].isPurchaseVolumeMaintained=='Y'||this.multipleSelection[i].isFarmMaintained=='Y'||this.multipleSelection[i].isFeedFactoryMaintained=='Y'||this.multipleSelection[i].isAuditorMaintained=='Y'||this.multipleSelection[i].isDrugListMaintained=='Y'||this.multipleSelection[i].isDrugDosageMaintained=='Y'||this.multipleSelection[i].isThirdPartyAuditReport=='Y'){
          return 2
        }else{
          return 1
        }
      }
    },
    onDel() {
      if(this.multipleSelection.length==0){
        this.$message.error('请先选择数据后再操作')
      }else{
        let status=this.getDeleteStatus()
        let params={
          rmcProduceFarmGroupIds:[],
          updateReason:""
        }
        this.multipleSelection.forEach((v)=>{
          params.rmcProduceFarmGroupIds.push(v.rmcProduceFarmGroupId)
        })
        // let isCreate=this.multipleSelection.some((v)=>{
        //   return v.farmGroupStatus!='Draft'
        // })
        let count=0
        this.multipleSelection.forEach((v)=>{
          if(v.farmGroupStatus=='New'||v.farmGroupStatus=='Inactive'||v.farmGroupStatus=='Delist'){
            count++
          }
        })
        if(count!=0){
          this.$message.error('仅可以删除状态为Draft和Active的主数据，请检查！')
        }else{
          if(status==1){
            this.$confirm('请确认是否删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              customClass: 'colorBtn',
              cancelButtonClass: 'btn_custom_cancel',
              type: 'warning'
            }).then(() => {
              farmGroup.deleteFarm(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('删除成功')
                  this.multipleSelection=[]
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            })
          }else if(status==2){
            this.$confirm('请确认是否删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              farmGroup.deleteFarm(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('删除成功')
                  this.multipleSelection=[]
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
          }else if(status==3){
            this.$prompt('', '请填写修改原因', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: (value) => {  
                if(!value) {
                  return '修改原因不能为空！';
                }
              },
            }).then(({ value }) => {
              this.$confirm('请确认是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'colorBtn',
                cancelButtonClass: 'btn_custom_cancel',
                type: 'warning'
              }).then(() => {
                params.updateReason=value
                farmGroup.deleteFarm(params).then((res)=>{
                  if(res.meta.code==200){
                    this.$message.success('删除成功')
                    this.multipleSelection=[]
                    this.queryData()
                  }else{
                    this.$message.error(res.meta.msg)
                  }
                })
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });       
            });
          }
        }
      }
    },
    // downFarmGroup(){
    //   farmGroup.downFarmGroup(this.queryCondition).then((res)=>{
    //       fileService.respToFile(res);
    //   })
    // },
    exportFarm(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let arr=[]
            this.multipleSelection.forEach((v)=>{
              arr.push(v.rmcProduceFarmGroupId)
            })
            let str=this.quarterList.filter((v)=>{
              return v.code==this.ruleForm.quarter
            })
            let newObj=Object.assign(this.queryCondition,this.ruleForm)
            newObj.rmcProduceFarmGroupIds=arr
            farmGroup.downFarmGroup(newObj).then((res)=>{
                fileService.respToFile(res,'FarmGroup主数据'+'_'+this.ruleForm.year+'_'+str[0].name+'.xlsx');
                this.exportDialog=false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
      });
    },
    changeStatus(val){
        let params={
            rmcProduceFarmGroupIds:[],
            updateReason:""
        }
        this.multipleSelection.forEach((v)=>{
          params.rmcProduceFarmGroupIds.push(v.rmcProduceFarmGroupId)
        })
        if(val==1){
          let num=0
          let strList=[]
          let statusList=[]
          this.statusList.forEach((v)=>{
            statusList.push(v.key)
          })
          this.multipleSelection.forEach((v)=>{
            strList.push(v.farmGroupStatus)
          })
          let isInactive=this.multipleSelection.every((v)=>{
            return v.farmGroupStatus=='Inactive'
          })
          new Set(strList).forEach((v)=>{
            if(v=='Inactive'||v=='Draft'||v=='New'||v=='Active'||v=='Delist'){
              num++
            }
          })
          console.log("走的11111==",num)
          if(num>1){
            this.$message.error('已勾选的数据状态不一致，请检查！')
          }else{
            if(isInactive){
              this.$prompt('', '请填写修改原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {  
                  if(!value&&isInactive) {
                    return '修改原因不能为空！';
                  }
                },
              }).then(({ value }) => {
                params.updateReason=value
                  farmGroup.farmActive(params).then((res)=>{
                    if(res.meta.code==200){
                      this.$message.success('启用成功')
                      this.queryData()
                    }else{
                      this.$message.error(res.meta.msg)
                    }
                  })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '取消输入'
                });       
              });
            }else{
              farmGroup.farmActive(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('启用成功')
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            }
          }
      }else if(val==2){
        let num=0
        let strList=[]
        let isActive=this.multipleSelection.every((v)=>{
          return v.farmGroupStatus=='Active'
        })
        let isNew=this.multipleSelection.every((v)=>{
          return v.farmGroupStatus=='New'
        })
        this.multipleSelection.forEach((v)=>{
          strList.push(v.farmGroupStatus)
        })
        new Set(strList).forEach((v)=>{
          if(v=='Inactive'||v=='Draft'||v=='New'||v=='Active'||v=='Delist'){
            num++
          }
        })
        if(num>1){
            this.$message.error('存在状态不一致的主数据无法同时禁用，请检查')
            // this.$message.error('主数据状态为New或者Active时才允许禁用，请检查。')
        }else{
          if(isActive||isNew){
            this.$prompt('', '请填写修改原因', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: (value) => {  
                if(!value) {
                  return '修改原因不能为空！';
                }
              },
            }).then(({ value }) => {
              params.updateReason=value
                farmGroup.farmInactive(params).then((res)=>{
                  if(res.meta.code==200){
                    this.$message.success('禁用成功')
                    this.queryData()
                  }else{
                    this.$message.error(res.meta.msg)
                  }
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });       
            });
          }else{
            this.$message.error('主数据状态为New或者Active时才允许禁用，请检查。')
          }
        }
      }
      // this.$prompt('', '请填写修改原因', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     inputValidator: (value) => {  
      //       if(!value) {
      //         return '修改原因不能为空！';
      //       }
      //     },
      //   }).then(({ value }) => {
      //     params.updateReason=value
      //     if(val==1){
      //       farmGroup.farmActive(params).then((res)=>{
      //         if(res.meta.code==200){
      //           this.$message.success('启用成功')
      //           this.queryData()
      //         }else{
      //           this.$message.error(res.meta.msg)
      //         }
      //       })
      //     }else if(val==2){
      //       farmGroup.farmInactive(params).then((res)=>{
      //         if(res.meta.code==200){
      //           this.$message.success('禁用成功')
      //           this.queryData()
      //         }else{
      //           this.$message.error(res.meta.msg)
      //         }
      //       })
      //     }
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '取消输入'
      //     });       
      //   });
    },
    exportData(){
      this.exportDialog=true
      if( this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!=-1 ){
        this.isBool=true
        this.ruleForm.year=moment().format("YYYY") 
        this.ruleForm.quarter='0'
      }else{
        this.isBool=false
      }
    },
    generateTodoList(){
      let isCreate=this.multipleSelection.some((v)=>{
        return v.farmGroupStatus!='New'
      })
      if(isCreate){
        this.$message.error('请选择New状态的数据生成')
      }else{
        let params={
          rmcProduceFarmGroupIds:[]
        }
        this.multipleSelection.forEach((v)=>{
          params.rmcProduceFarmGroupIds.push(v.rmcProduceFarmGroupId)
        })
        farmGroup.generateTodoList(params).then((res)=>{
          if(res.meta.code==200){
            this.$message.success('生成待办任务')
            this.multipleSelection=[]
            this.queryData()
          }else{
            this.$message.error(res.meta.msg)
          }
        })
      }
    },
    deleteTodoList(){
      let params={
        rmcProduceFarmGroupIds:[]
      }
      this.multipleSelection.forEach((v)=>{
        params.rmcProduceFarmGroupIds.push(v.rmcProduceFarmGroupId)
      })
      farmGroup.deleteTodoList(params).then((res)=>{
        if(res.meta.code==200){
          this.$message.success('删除待办任务')
          this.multipleSelection=[]
          this.queryData()
        }else{
          this.$message.error(res.meta.msg)
        }
      })
    },
    addFarmGroup(){
        this.$router.push({
            path:"/rmcProdFarmGroup/detail",
            query:{

            }
        })
    },
    closeDialog(){
      this.showDetailDialog=false
      this.queryData()
    },
    selectionChange(val){
      this.multipleSelection=val
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
.orColor{
  color: #F8AB01;
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor:pointer;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
</style>
